<template>
  <div class="flex flex-col p-6 shadow-sm-1 rounded-lg bg-white">
    <div
      class="trustpilot-compact-review flex flex-col items-center justify-center mb-6 last:mb-0 cursor-pointer"
      @click="handleLink()"
    >
      <NuxtImg
        src="/icons/trustpilot/trustpilot.svg"
        alt="trustpilot"
        width="82"
        height="20"
        class="mb-[0.625rem]"
        :loading="props.imageLazyLoad ? 'lazy' : 'eager'"
      />

      <NuxtImg
        v-if="!_isEmpty(data)"
        :src="`https:${data && data.starsImage.url}`"
        :width="data && data.starsImage.width"
        :height="data && data.starsImage.height"
        alt="trustpilot rate"
        :loading="props.imageLazyLoad ? 'lazy' : 'eager'"
      />

      <div class="flex text-sm leading-[1.4rem] mt-2 mb-4">
        <div class="pr-[0.625rem] border-r-1 border-gray-400">
          TrustScore {{ data && data.trustScore }}
        </div>

        <div class="font-bold underline pl-[0.625rem]">
          {{ data && data.numberOfReviews.total }} reviews
        </div>
      </div>

      <div
        v-if="!_isEmpty(trustpilotSingleReview)"
        class="border-t-1 border-gray-400 text-xs leading-[1.125rem] pt-[0.9375rem]"
      >
        <p class="font-bold text-sm mb-[0.3125rem]">
          {{ trustpilotSingleReview.title }}
        </p>

        <p class="mb-[0.8125rem]">
          {{ trustpilotSingleReview.text }}
        </p>

        <p>
          {{ trustpilotSingleReview.customer }}, {{ toHours(trustpilotSingleReview.createdAt) }}
        </p>
      </div>

      <div
        v-if="!_isEmpty(latestReview) && _isEmpty(trustpilotSingleReview) && !hideReview"
        class="border-t-1 border-gray-400 text-xs leading-[1.125rem] pt-[0.9375rem]"
      >
        <p class="font-bold text-sm mb-[0.3125rem]">
          {{ latestReview.title }}
        </p>

        <p class="mb-[0.8125rem]">
          {{ latestReview.text }}
        </p>

        <p>
          {{ latestReview.customer }}, {{ toHours(latestReview.createdAt) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import _isEmpty from 'underscore/cjs/isEmpty.js'

// Extend the dayjs with relativeTime plugin
try {
  dayjs.extend(relativeTime)
} catch (error) {
  throw new Error(error)
}

const trustpilotStore = useTrustpilotStore()

defineOptions({
  name: 'MoleculesTrustpilotCompactReview'
})

const toHours = date => {
  return dayjs(date).fromNow()
}

const props = defineProps({
  stars: {
    type: String,
    default: '4,5'
  },

  tags: {
    type: String,
    default: ''
  },

  reviewId: {
    type: String,
    default: '',
    required: false
  },

  imageLazyLoad: {
    type: Boolean,
    default: false
  },

  hideReview: {
    type: Boolean,
    default: false
  }
})

// Fetch data if it's not already loaded
if (!trustpilotStore.trustpilotData && !trustpilotStore.trustpilotDataHasError) {
  // Get data from trustpilot
  await trustpilotStore.fetchTrustpilotData()
}

const data = computed(() => trustpilotStore.trustpilotData)

if (props.reviewId) {
  await trustpilotStore.fetchReviewById({ id: props.reviewId })
} else if (!trustpilotStore.trustpilotReviews && !trustpilotStore.isLoadingTrustpilotReviews && !trustpilotStore.trustpilotReviewsHasError) {
  await trustpilotStore.fetchReviews(removeFalseyObj({
    stars: props.stars,
    tagValue: props.tags
  }))
}

const trustpilotSingleReview = computed(() => trustpilotStore.trustpilotSingleReview)
const latestReview = computed(() => {
  return trustpilotStore.latestReview
})

function handleLink () {
  if (!data.value?.profileUrl) {
    // eslint-disable-next-line no-console
    return console.error('profileUrl is required!')
  }

  return window.open(data.value.profileUrl, '_blank')
}
</script>
